module.exports = __webpack_public_path__ + "img/shield_on_hold.960f5b67.svg";